import { jsx as _jsx } from "react/jsx-runtime";
import '@styles/webdesktop/stylesheets/link.scss';
import { Foreground } from '@front/sharedcomponents/Styles';
import { Typography } from '../Typography/Typography';
import { TypographyLevel } from '../Typography/TypographyLevel';
export const Link = ({ text, href, level = TypographyLevel.BodySm, noWrap = false }) => {
    const classNames = ['link', Foreground.Toggle, noWrap ? 'link-nowrap' : ''].filter(Boolean).join(' ');
    return (_jsx("a", { className: classNames, href: href, target: "_blank", rel: "noopener noreferrer", children: _jsx(Typography, { level: level, noWrap: noWrap, children: text }) }));
};
